module.exports = __webpack_public_path__ + "img/question18c2.f59800ca.png";